import { setCookie, getCookie} from "../util/cookies";

export default class CountrySwitcher {
  constructor()
  {
    this.buttons = document.querySelectorAll('[data-toggle="countrySwitcher"]');
    this.currentCountry = getCookie('customer_country_code');
    this.selectorsToUpdate = document.querySelectorAll('select[name="your-country"], select[name="review_customer_country"]');
    this.dropdownCountry = document.querySelector('#topCountrySelect');
    this.countrySearch = document.querySelectorAll('[data-toggle="countrySearch"]');

    this.addHandlers();
  }

  addHandlers()
  {
    if(this.buttons && this.buttons.length > 0) {
      this.buttons.forEach(button => button.addEventListener('click', this.switchCountry.bind(this)));
    }

    //Scroll active county in to view in dropdown selector
    if(this.dropdownCountry) {
      this.dropdownCountry.addEventListener('shown.bs.dropdown', event => {
        const parent = event.target.closest('.dropdown');
        const active = parent.querySelector('.active');
        if(active) {
          active.scrollIntoView();
        }
      });
    }

    if(this.countrySearch && this.countrySearch.length > 0) {
      this.countrySearch.forEach(search => search.addEventListener('keyup', this.filter.bind(this)));
    }
  }

  switchCountry(event)
  {
    const button = event.currentTarget;
    const code = button.dataset.code;
    const name = button.textContent.trim();

    if(code === this.currentCountry) {
      return;
    }

    this.currentCountry = code;
    setCookie('customer_country_code', code, {
      'path': '/'
    });
    this.setIndicator(code, name);
    this.setActiveButton(code);
    this.updateSelectors(code);
    this.updateGlobalValues(code, name);
  }

  setIndicator(code, name)
  {
    const indicators = document.querySelectorAll('.country-indicator');

    if(!indicators || indicators.length === 0) {
      return;
    }

    indicators.forEach(indicator => {
      for (let i = 0, l = indicator.classList.length; i < l; ++i) {
        if(/fflag-.*/.test(indicator.classList.item(i))) {
          indicator.classList.remove((indicator.classList.item(i)));
          break;
        }
      }

      indicator.classList.add(`fflag-${code}`);

      const nameWrap = indicator.querySelector('.country-name');

      if(nameWrap) {
        nameWrap.textContent = name;
      }
    });


  }

  setActiveButton(code)
  {
    this.buttons.forEach(button => {
      button.classList.toggle('active', code === button.dataset.code);
    });
  }

  updateSelectors(code)
  {
    if(!this.selectorsToUpdate || this.selectorsToUpdate.length === 0) {
      return;
    }

    this.selectorsToUpdate.forEach(select => {
      select.value = code;
      select.dispatchEvent(new Event('change'));
    });
  }

  updateGlobalValues(code, name)
  {
    palram.default_country_code = code;
    palram.default_country_name = name;
  }

  filter(event)
  {
    const items = event.target.closest('.country-filter-parent').querySelectorAll('.country-filter-item');
    if(!items || items.length === 0 ) {
      return;
    }

    const value = event.target.value.toUpperCase();

    items.forEach(item => {
      const button = item.querySelector('button');
      const name = button.textContent.toUpperCase();

      if(name.indexOf(value) > -1) {
        item.removeAttribute('style');
      } else {
        item.style.display = 'none';
      }
    });

  }
}
